import { Flex } from '@gazin/ecommerce-ui'
import { displayDiscountTagAndEvent } from 'src/util/promotionalEvent'

type DiscountTagProps = {
  discountPercentage: number
  isAvailable?: boolean
}

export default function DiscountTag({
  discountPercentage,
  isAvailable = true,
}: DiscountTagProps) {
  return (
    <>
      {displayDiscountTagAndEvent({ discountPercentage, isAvailable }) && (
        <Flex
          alignItems="center"
          background="#6bb70b"
          borderRadius="0.375rem"
          color="#ffffff"
          fontSize="0.75rem"
          fontWeight="600"
          justifyContent="center"
          lineHeight="0.875rem"
          minH="1.125rem"
          minW="2.688rem"
        >
          {`-${discountPercentage}%`}
        </Flex>
      )}
    </>
  )
}
